import { localePath } from './router.utils'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (Vue: any) => {
  const instance = localePath
  const propName = 'localePath'
  Vue[propName] = instance
  Vue.prototype[propName] = instance
}
